<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;

  .gy-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .gy-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .gy-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .gy-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }

  .tj-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .tj-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .tj-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .tj-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }
}

.left {
  display: flex;
  align-items: center;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}

.content-box {
  display: flex;
  justify-content: space-between;
  color: #f56c6c;
  margin-top: 20px;
  font-size: 14px;

  .box1 {
    align-self: flex-start;
  }

  .box2 {
    align-self: flex-end;
    color: #e6a23c;
  }
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows"> </yi_curd_table>
    <div class="container">
      <div class="form">
        <div>
          <el-form size="mini" :model="conditions" :inline="true">
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="conditions.equipmentId"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('mujumingcheng')">
              <yi_cross_select :max="1" :component="'web_base_mould_list'" :ids.sync="conditions.mouldId"> </yi_cross_select>
            </el-form-item>
            <el-form-item>
              <el-button @click="search" type="primary" plain="plain">
                {{ $t('sousuo') }}
              </el-button>
              <el-button @click="resetClear">{{ $t('chongzhi') }} </el-button>
            </el-form-item>
            <el-button type="primary" size="mini" @click="distribute" :loading="loading">{{ $t('quedingxiafa') }}</el-button>
            <div class="left">
              <span class="icon"></span>
              <span class="txt">{{ $t('shishicanshu') }}</span>
            </div>
            <!--操作模式-->
            <div v-if="lengthList" style="color: #606266;margin-top: 8px">
              {{ $t('caozuomoshi') }}:
              <span style="margin-left: 10px">
                <span v-if="editParam.pattern === 1">{{ $t('shoudongmoshi') }}</span>
                <span v-if="editParam.pattern === 0">{{ $t('feishoudongmoshi') }}</span>
              </span>
            </div>
          </el-form>
        </div>
        <div>
          <div v-if="lengthList">
            <!--选中的点和可编辑颜色提示-->
            <div class="content-box">
              <div class="box1">
                <span v-if="editParam.lowerLimit || editParam.upperLimit || editParam.value || editParam.craftGuideParamsItem">
                  {{ eqCodeName }}: {{ $t('cankaozhi') }}:{{ editParam.craftGuideParamsItem == null ? $t('wu') : editParam.craftGuideParamsItem.value }}{{ ',' }} {{ $t('shangpiancha') }}:{{ editParam.upperLimit == null ? '' : editParam.upperLimit.toFixed(2) }} {{ ',' }}{{ $t('xiapiancha') }}:{{ editParam.lowerLimit == null ? '' : editParam.lowerLimit.toFixed(2) }}
                  <span style="margin-left: 20px"> {{ $t('dangqianzhi') }}:{{ editParam.value == null ? '' : Math.floor(editParam.value * 100) / 100 }} </span>
                  <span style="margin-left: 20px">{{ $t('xiugaizhi') }}:{{ editValueItem.editValue }}</span>
                </span>
              </div>
              <div class="box2"><i class="el-icon-question"></i>{{ $t('biaogeyansebiaozhu') }}</div>
            </div>
            <div ref="myElement" class="gy-html" v-html="gy" @click="onClickGyHtml"></div>
          </div>
          <div v-else style="margin-top: 220px">
            <el-empty :image-size="80" :description="$t('qingzaisousuolanxuanzeshebeihemujumingcheng')"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
// import execMathExpress from "exec-mathexpress";
// const execMathExpress = require('exec-mathexpress');
const Base64 = require('js-base64').Base64;
export default {
  name: 'web_process_management_adjustment_index',
  components: {},
  data() {
    return {
      maxValue: 0,
      minValue: 0,
      loading: false,
      base64: Base64,
      conditions: {},
      gyHtml: '',
      singleMonitorData: '', //点
      eqCodeName: '', //设备点名
      msgCode: '', //下发点提示
      codeList: [],
      showElement: false,
      lengthList: null,
      selectCode: '',
      editParam: {},
      codeValue: '',
      editValueItem: {
        currentValue: '', // 当前值
        editValue: '' // 修改值
      },
      updatePointList: [], // 修改的点
      canEditPointList: [], // 可编辑的点
      mouldIdList: '',
      tipValue: null
    };
  },

  computed: {
    gy() {
      if (this.store.state.eqPoints[this.conditions.equipmentId] === undefined) {
        this.utils.errorMessage(this.$t('shujvweijiazaiwan'));
        return;
      }
      try {
        let str = this.gyHtml;
        str = this.base64.decode(str);
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1) &&
          str.match(reg1).map(code => {
            let c = code.replace('[', '');
            c = c.replace(']', '');
            str = str.replace(code, this.$t(c));
          });

        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2) &&
          str.match(reg2).map(code => {
            let c = code.replace('{', '');
            c = c.replace('}', '');
            if (!this.store.state.eqPoints[this.conditions.equipmentId][c]) {
              console.log('gongyimobanqueshaodian' + ':' + c);
              return;
            }
            let prec = this.store.state.eqPoints[this.conditions.equipmentId][c].prec;

            if (this.store.state.eqPoints[this.conditions.equipmentId][c].dictTypeCode != null) {
              str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.store.state.eqPoints[this.conditions.equipmentId][c].dictTypeCode][parseInt(this.singleMonitorData[c])]));
            } else {
              str = str.replace(code, isNaN(Number(this.singleMonitorData[c]).toFixed(prec == null ? 2 : prec)) ? '' : Number(this.singleMonitorData[c]).toFixed(prec == null ? 2 : prec));
            }
          });

        return str;
      } catch (error) {
        console.error(error);
      }
    }
  },
  created() {
    setTimeout(() => {}, 300);
  },
  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    //确定下发
    distribute() {
      if (this.updatePointList.length === 0) {
        this.utils.errorMessage(this.$t('canshudianshujuweigenggai'));
      } else {
        if (this.editParam.pattern === 1) {
          this.loading = true;
          const result = [];
          result.push({
            code: this.codeValue,
            v: this.editValueItem.editValue
          });
          let params = {
            equipmentId: this.conditions.equipmentId,
            mouldId: this.conditions.mouldId,
            craftDebugEditVOList: this.updatePointList
          };
          this.http
            .post('/web/craft/debug/log/confirm', params)
            .then(res => {
              this.utils.successMessage(this.$t(res.msg));
              this.loading = false;
              this.updatePointList = [];
            })
            .catch(msg => {
              const reg = /\[(\d+)\]/;
              const match = reg.exec(msg);
              const value = match ? match[1] : null;
              let matchs = /\](.+)/.exec(msg); // 匹配 "] " 号后面的值
              this.tipValue = matchs[1]; // 取匹配到的值

              let results = msg.match(/\[(.*?)\]/);
              let extractedValue = results ? results[1] : null;
              if (extractedValue !== null) {
                if (this.$t(this.store.state.eqPoints[this.conditions.equipmentId][value].alias) === undefined) {
                  this.msgCode = this.$t(this.store.state.eqPoints[this.conditions.equipmentId][value].alias);
                } else {
                  this.msgCode = this.$t(this.store.state.eqPoints[this.conditions.equipmentId][value].alias) + '(' + this.$t(this.store.state.eqPoints[this.conditions.equipmentId][value].unit) + ')';
                }
                const msgTip = this.msgCode + this.tipValue;
                setTimeout(() => {
                  this.utils.errorMessage(msgTip);
                  this.loading = false;
                }, 100);
              } else {
                this.loading = false;
                this.utils.errorMessage(msg);
              }
            });
        } else {
          this.utils.errorMessage(this.$t('zhiyoushoudongmoshicaikeyixiafagongyi'));
        }
      }
    },
    onClickGyHtml(event) {
      if (event) {
        const that = this;
        const cell = event.target;
        console.log('eventcell', cell, cell.getAttribute('contenteditable'));
        if (cell.getAttribute('contenteditable')) {
          this.selectCode = cell.getAttribute('code');
          this.getCurrentValue();
        }

        // this.editValueItem.editValue = ''
        // if (cell && this.editableCell) {
        //   this.editParam.currentValue = cell.innerText
        // }
        // if (!/^(\d+|\d+\.\d+)$/.test(String(cell.textContent)) || /^[\u4E00-\u9FA5\uF900-\uFA2D\w\s]+$/.test(cell.textContent)) {
        //   return;
        // }
        const table = cell.closest('table');
        if (!table) {
          return;
        }

        const tbody = table.querySelector('tbody'); // 获取 <table> 元素下的 <tbody> 元素
        const tr = tbody.querySelector('tr:first-child'); // 获取 <tbody> 元素下的第一个 <tr> 元素
        const td = tr.querySelector('td'); // 获取 <tr> 元素下的第一个 <td> 元素
        const text = td.textContent; // 获取 <td> 元素的文本内容
        console.log('event', tbody);
        //判断拿到的点如故与表格中匹配的点是否相等、相等则可编辑并标为黄色
        if (cell.attributes.code.value !== null || cell.attributes.code.value !== undefined) {
          this.codeList
            .filter(item => item.code === cell.attributes.code.value)
            .map(items => {
              // console.log('ddddddss',items)
              if (items) {
                cell.setAttribute('contenteditable', 'true'); //开启编辑
                //获取选中的code值
                this.selectCode = cell.attributes.code.value;
                // this.updateHtml(this.selectCode)
                //获取当前值
                // this.editValueItem.currentValue = cell.innerText
                //获取设备点的名称
                if (this.$t(this.store.state.eqPoints[this.conditions.equipmentId][cell.attributes.code.value].alias) === undefined) {
                  this.eqCodeName = this.$t(this.store.state.eqPoints[this.conditions.equipmentId][cell.attributes.code.value].alias);
                } else {
                  this.eqCodeName = this.$t(this.store.state.eqPoints[this.conditions.equipmentId][cell.attributes.code.value].alias) + '(' + this.$t(this.store.state.eqPoints[this.conditions.equipmentId][cell.attributes.code.value].unit) + ')';
                }
                this.codeValue = cell.attributes.code.value;
                this.getCurrentValue(); //根据可编辑点获取参考值
                cell.addEventListener('input', function() {
                  const value = cell.innerText.trim(); // 获取单元格的值并去除首尾空格
                  console.log('监听', value);
                  if (value == '') {
                    // cell.innerText = that.editParam.currentValue
                  } else {
                    const regex = /^\d+(\.\d{0,2})?$/; // 正则表达式，只允许数字和最多两位小数

                    // 输入不符合要求，阻止默认行为并更正输入值
                    if (!regex.test(value)) {
                      event.preventDefault();
                      cell.innerText = value.replace(/[^\d.]/g, ''); // 只保留数字和小数点
                      const decimalIndex = cell.innerText.indexOf('.'); // 获取小数点索引
                      if (decimalIndex >= 0) {
                        cell.innerText = cell.innerText.slice(0, decimalIndex + 3); // 保留两位小数
                      }
                    } else {
                      cell.style.color = '#ffffff';
                      if (that.editParam.upperLimit && that.editParam.lowerLimit) {
                        //如果有参考值
                        console.log('如果有参考值', 111111);
                        that.maxValue = that.editParam.upperLimit;
                        that.minValue = that.editParam.lowerLimit;

                        if (value > that.maxValue || value < that.minValue) {
                          cell.style.background = '#F56C6C';
                        } else {
                          cell.style.background = '#67C23A';
                        }
                      } else {
                        //如果没有参考值
                        console.log('如果没有参考值', 22222);
                        // const point = that.canEditPointList.find(item => {
                        //   item.code === cell.setAttribute('code')
                        // })
                        that.maxValue = that.editParam.value + that.editParam.value * 0.1;
                        that.minValue = that.editParam.value - that.editParam.value * 0.1;
                        console.log('that.maxValue', that.maxValue);
                        console.log(' that.minValue', that.minValue);
                        // return a >= lowerRange && a <= upperRange; // 没有上下偏差时，判断是否在取值范围内
                        if (value > that.maxValue || value < that.minValue) {
                          cell.style.background = '#F56C6C';
                        } else {
                          cell.style.background = '#67C23A';
                        }
                      }
                      // editParam.value
                      console.log('ddddd', value);
                      // if (value > maxValue || value < minValue) {
                      //   cell.style.background = '#F56C6C'
                      // } else {
                      //   cell.style.background = '#67C23A'
                      // }

                      that.editValueItem.editValue = value;
                      const codeList = that.updatePointList.map(item => {
                        return item.code;
                      });
                      console.log(codeList);
                      if (!codeList.includes(cell.attributes.code.value)) {
                        that.updatePointList.push({
                          code: cell.attributes.code.value,
                          v: cell.innerText
                        });
                      } else {
                        for (let i = 0; i < that.updatePointList.length; i++) {
                          if (that.updatePointList[i].code === cell.attributes.code.value) {
                            that.updatePointList[i].v = cell.innerText;
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
        }
      }
    },
    fetchHtml() {
      let tables = document.getElementsByClassName('gy-html')[0].getElementsByTagName('table');
      console.log('ffffff', tables);
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName('tr');

        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName('td');

          for (var k = 0; k < tds.length; k++) {
            const code = tds[k].getAttribute('code');

            // console.log('111111', tds[k].getAttribute("code"))
            //匹配出可编辑的code作为可编辑标志
            this.codeList
              .filter(item => item.code === tds[k].getAttribute('code'))
              .map(items => {
                if (items) {
                  tds[k].querySelector('td');
                  tds[k].style.backgroundColor = '#FFE9C9'; //给可编辑点加背景颜色
                  tds[k].style.color = '#606266';
                  this.canEditPointList.push({
                    code: items.code,
                    v: tds[k].innerText
                  });
                }
              });
          }
        }
      }
    },
    async search() {
      this.editParam.value = '';
      this.editParam.pattern = '';
      this.$nextTick(() => {
        let params = {
          equipmentId: this.conditions.equipmentId,
          mouldId: this.conditions.mouldId
        };
        if (Array.isArray(params['equipmentId']) && params['equipmentId'].length > 0) {
          params['equipmentId'] = params['equipmentId'].join(',');
        }
        return this.http
          .get('/web/config/craft/template/monitor/tab?' + this.qs.stringify(params))
          .then(async response => {
            if (response.data.tab === undefined || response.data.tab === null) {
              this.$message.error(this.$t('qingpeizhimuban'));
            } else {
              this.lengthList = response.data;
              this.gyHtml = response.data.tab.gy;
              this.gkHtml = response.data.tab.gk;
              await this.getSingleMonitorData();
              await this.getEditRecord();
              await this.fetchHtml();
            }

            this.updatePointList = [];
          })
          .catch(msg => {
            this.utils.errorMessage(this.$t(msg));
          });
      });
    },
    //重置
    resetClear() {
      this.lengthList = '';
      this.conditions.equipmentId = '';
      this.conditions.mouldId = null;
      this.editParam.craftGuideParamsItem = '';
      this.eqCodeName = null;
      this.editParam.value = null;
      this.editParam.upperLimit = null;
      this.editParam.lowerLimit = null;
      this.editValueItem.editValue = null;
      this.updatePointList = [];
      // this.search()
    },
    //获取点
    async getSingleMonitorData() {
      let response = await this.http.get('/web/equipment/getMesSingleMonitorData', {
        params: {
          equipmentId: this.conditions.equipmentId
        }
      });
      this.singleMonitorData = response.data;
    },
    //获取可编辑的点
    async getEditRecord() {
      let response = await this.http.get('/web/craft/debug/log/getEditRecord', {
        params: {
          equipmentId: this.conditions.equipmentId
        }
      });
      this.codeList = response.data;
    },
    //获取参考值
    async getCurrentValue() {
      this.editValueItem.editValue = null;
      if (this.conditions.mouldId == undefined) {
        this.mouldIdList = '';
      } else {
        this.mouldIdList = this.conditions.mouldId;
      }
      await this.http
        .post('/web/craft/debug/log/getCurrentValue?equipmentId=' + this.conditions.equipmentId + '&code=' + parseInt(this.selectCode) + '&mouldId=' + this.mouldIdList)
        .then(res => {
          this.editParam = res.data;
          console.log('this.editParam', this.editParam);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    }
  }
};
</script>
